import { z } from 'zod';

//TODO: Move to a shared importer with BE.

// Zod schemas for streamed itinerary payload MUST match the BE lin/itinerary.mjs
export const ItineraryItemSchema = z
  .object({
    day: z.number(),
    date: z.string(),
    amActivity: z.string().nullable(),
    amAttractionId: z.string().nullable(),
    amAttractionInterest: z.number().nullable(),
    pmActivity: z.string().nullable(),
    pmAttractionId: z.string().nullable(),
    pmAttractionInterest: z.number().nullable(),
    dinner: z.string(),
    dinnerUrl: z.string().nullable(),
    accommodations: z.string(),
    accommodationsUrl: z.string().nullable(),
    notes: z.string(),
  })
  .passthrough(); // Allow additional fields

export const ItinerarySchema = z.object({
  itinerary: z.array(ItineraryItemSchema),
});

// Inferred TypeScript types
export type ItineraryItem = z.infer<typeof ItineraryItemSchema>;
export type Itinerary = z.infer<typeof ItinerarySchema>;
